import React from "react";
import { Handshake } from "lucide-react";

export const PWTPartnership = () => {
  return (
    <section
      id="pwt"
      data-testid="pwt-section"
      className="bg-brand-off-white text-brand-teal py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-3">
            <span className="overline text-[#2EC4B6]">— Strategic alliance</span>
          </div>

          <div className="md:col-span-9">
            <div className="flex items-center gap-4 mb-8">
              <div className="h-12 w-12 border border-brand-teal/20 flex items-center justify-center">
                <Handshake size={22} strokeWidth={1.5} className="text-[#2EC4B6]" />
              </div>
              <span className="font-display text-2xl tracking-tight">
                PWT &nbsp;<span className="text-brand-teal/40 text-lg font-display-medium">·  Performance With Trust</span>
              </span>
            </div>

            <h2
              className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05]"
              data-testid="pwt-heading"
            >
              Proud partners of PWT — the ecosystem that
              <span className="text-[#2EC4B6]"> pairs performance with trust.</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12">
              <p className="text-lg text-muted-dark leading-relaxed">
                We collaborate with PWT on Innovation and Strategy initiatives,
                bringing our four divisions into a wider network of specialists
                that share our standards.
              </p>
              <p className="text-lg text-muted-dark leading-relaxed">
                PWT is an ecosystem of independent boutiques offering
                professional services in business transformation — combining
                deep expertise with the discipline of partnership-led work.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-brand-teal/10 mt-14 border border-brand-teal/10">
              {[
                ["Performance", "Sharper outcomes, measurable impact"],
                ["With Trust", "Long-term partnership over transactions"],
                ["Boutique scale", "Senior practitioners on every project"],
              ].map(([title, sub], i) => (
                <div
                  key={title}
                  data-testid={`pwt-pillar-${i}`}
                  className="bg-brand-off-white p-8"
                >
                  <div className="font-display text-2xl tracking-tight mb-2">
                    {title}
                  </div>
                  <p className="text-sm text-muted-dark leading-relaxed">{sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PWTPartnership;
